export const aciScreen = {
    iconName: 'screen',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 15 23' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M3.753 11.236c.384.183.105.766-.278.583C1.282 10.769 0 8.64 0 6.222 0 2.718 2.682 0 6.234 0c2.274 0 4.414 1.214 5.494 3.23.833 1.557.95 3.499.37 5.163-.139.401-.75.189-.61-.213.519-1.49.416-3.252-.33-4.646C10.19 1.73 8.268.65 6.234.65 3.037.649.649 3.069.649 6.222c0 2.17 1.134 4.07 3.104 5.014z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M3.85 8.39c.29.31-.182.75-.472.44-.671-.718-.964-1.636-.964-2.608 0-2.25 1.63-3.788 3.815-3.788s3.815 1.538 3.815 3.788c0 .518-.087 1.04-.278 1.523-.157.395-.758.157-.601-.238.164-.412.23-.843.23-1.285 0-1.884-1.34-3.139-3.166-3.139-1.825 0-3.167 1.255-3.167 3.139 0 .803.23 1.572.788 2.167z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M5.346 15.638c0 .32-.413.443-.591.184L3.022 13.72c-.74-.898-2.113.216-1.368 1.118l3.712 4.495c3.525 4.268 8.988 2.256 8.988-2.55v-5.314c0-1.167-1.766-1.167-1.766 0v1.334c0 .426-.65.426-.65 0v-2.017c0-1.167-1.764-1.167-1.764 0v2.017c0 .426-.649.426-.649 0v-2.7c0-1.167-1.765-1.167-1.765 0v2.7c0 .426-.649.426-.649 0V6.22c0-1.167-1.765-1.167-1.765 0v9.417zm4.748-6.06c.8-.6 2.086-.316 2.414.682.978-.733 2.492-.143 2.492 1.209v5.313c0 5.395-6.212 7.711-10.133 2.964L1.155 15.25c-1.288-1.56 1.077-3.506 2.366-1.942l1.177 1.427V6.221c0-2.024 3.062-2.024 3.062 0V8.84c.808-.526 2.017-.226 2.334.739z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
